import type { AdminUser } from '$lib/types';

// AdminUser.projects (from GET /api/admin/users) is ONLY a member's *extra*
// grants (internal/api/handlers/admin_users.go's userJSON plucks
// user_projects, which never includes the primary project_id row) — a
// member's actual accessible set is project_id (primary) UNION projects
// (extra grants), same union middleware.AccessibleProjectIDs computes
// server-side. Anything that wants "does this user have access to project
// X" must check both; forgetting project_id here previously made a
// primary-only member (the common case — created via "Primary project" in
// the New user modal) invisible on their own project's card.
export function userProjectIds(user: Pick<AdminUser, 'project_id' | 'projects'>): number[] {
  const ids = new Set(user.projects);
  if (user.project_id !== null) ids.add(user.project_id);
  return [...ids];
}

export function userHasProject(user: Pick<AdminUser, 'project_id' | 'projects'>, projectId: number): boolean {
  return user.project_id === projectId || user.projects.includes(projectId);
}
